import Vue from 'vue'
import axios from 'axios'

Vue.prototype.$api = axios
Vue.prototype.$api.defaults.baseURL = App.Api.Url